import { Box } from "@mui/material";
import CustomTextArea from "@/components/CustomTextArea";
import { UseCosignFlowResult } from "../hooks/use-cosign-flow";
import {
  COSIGN_STEP,
  NOTE_PREVIEW_BODY_FONT_SIZE_PX,
  NOTE_PREVIEW_COSIGN_HEADING_BACKGROUND,
  NOTE_PREVIEW_COSIGN_NOTE_FIELD,
  NOTE_PREVIEW_COSIGN_NOTE_ROWS,
  NOTE_PREVIEW_LABELS,
  NOTE_PREVIEW_PAPER_PADDING_PX,
} from "../note-preview-constant";
import { NotePreviewView } from "../note-preview-types";
import CosignPinDialog from "./CosignPinDialog";
import CosignSignatureDialog from "./CosignSignatureDialog";

export interface CosignPanelProps {
  flow: UseCosignFlowResult;
  view: NotePreviewView;
}

/** Co-signer note editor under the report (once Edit Note is pressed) plus the PIN and signature dialogs. */
const CosignPanel = ({ flow, view }: CosignPanelProps) => (
  <>
    {flow.form.isEditingNote && (
      <Box
        sx={{
          px: `${NOTE_PREVIEW_PAPER_PADDING_PX}px`,
          pb: `${NOTE_PREVIEW_PAPER_PADDING_PX}px`,
          fontSize: NOTE_PREVIEW_BODY_FONT_SIZE_PX,
        }}
      >
        <Box
          sx={{
            bgcolor: NOTE_PREVIEW_COSIGN_HEADING_BACKGROUND,
            px: 1,
            py: 0.5,
            mb: 1,
            fontWeight: 600,
          }}
        >
          {NOTE_PREVIEW_LABELS.cosignerNote}
        </Box>
        <CustomTextArea
          name={NOTE_PREVIEW_COSIGN_NOTE_FIELD}
          multiline
          minRows={NOTE_PREVIEW_COSIGN_NOTE_ROWS}
          fullWidth
          placeholder={NOTE_PREVIEW_LABELS.cosignerNotePlaceholder}
          value={flow.form.note}
          onChange={(event) => flow.form.onNoteChange(event.target.value)}
          onBlur={flow.form.onNoteBlur}
          error={!!flow.form.noteError}
          helperText={flow.form.noteError}
        />
      </Box>
    )}
    {flow.step === COSIGN_STEP.PIN && (
      <CosignPinDialog
        open
        noteTitle={view.title}
        signature={view.signature}
        isVerifying={flow.isVerifyingPin}
        onCancel={flow.cancelStep}
        onVerify={flow.verifyPin}
      />
    )}
    {flow.step === COSIGN_STEP.SIGN && (
      <CosignSignatureDialog
        open
        isSubmitting={flow.isSigning}
        onCancel={flow.cancelStep}
        onSubmit={flow.signWithSignature}
      />
    )}
  </>
);

export default CosignPanel;
